export type Stop = { id:number; day:number; date:string; time:string; name:string; note:string; lat?:number; lng?:number };

export const stops: Stop[] = [
  { id:0, day:0, date:"8/6（四）", time:"17:41", name:"高鐵 846 車次", note:"17:41 台南 → 19:31 板橋・前一日北上銜接隔日桃園出發航班" },
  { id:1, day:1, date:"8/7（五）", time:"15:10", name:"新千歲機場", note:"JX850 10:05 桃園機場 → 15:10 新千歲・16:30 取車", lat:42.7752, lng:141.6923 },
  { id:2, day:1, date:"8/7（五）", time:"17:20", name:"Mother's Plus 白老", note:"取車後順路採買甜點・雞蛋布丁與伴手禮", lat:42.5477, lng:141.2982 },
  { id:22, day:1, date:"8/7（五）", time:"18:30", name:"Darumatei Shiraoi", note:"晚餐・白老牛／燒肉・餐後前往汐之湯溫泉", lat:42.5511, lng:141.3558 },
  { id:3, day:2, date:"8/8（六）", time:"09:00", name:"白老聚會", note:"安息日聚會", lat:42.5489, lng:141.3588 },
  { id:4, day:2, date:"8/8（六）", time:"10:40", name:"ナチュの森 あそびのひろば", note:"室內氣墊遊具・9歲女童放電・小學生以下 ¥700/小時", lat:42.4617, lng:141.1814 },
  { id:5, day:2, date:"8/8（六）", time:"11:35", name:"㈱山珍", note:"買魷魚絲／珍味・常溫小包裝伴手禮優先", lat:42.4624, lng:141.1818 },
  { id:23, day:2, date:"8/8（六）", time:"12:05", name:"かに太郎", note:"午餐・建議控制在 45 分鐘內，13:00 前離開白老", lat:42.5489, lng:141.3588 },
  { id:24, day:2, date:"8/8（六）", time:"13:00", name:"離開白老", note:"往京極名水公園・安全行車目標時間", lat:42.5489, lng:141.3588 },
  { id:25, day:2, date:"8/8（六）", time:"15:00", name:"京極名水公園", note:"名水・炸肉餅・咖啡・快速停留", lat:42.8588, lng:140.8711 },
  { id:26, day:2, date:"8/8（六）", time:"16:30", name:"仁木・余市", note:"きのこ王國・余市周邊", lat:43.1547, lng:140.7683 },
  { id:6, day:3, date:"8/9（日）", time:"09:00", name:"山本觀光果園", note:"採藍莓、櫻桃", lat:43.1614, lng:140.7729 },
  { id:28, day:3, date:"8/9（日）", time:"10:30", name:"道の駅 スペース・アップルよいち", note:"余市町道の駅短停・蘋果派、蘋果汁、在地水果加工品與伴手禮・電話 0135-22-1515・位於國道 229 旁方便導航搜尋", lat:43.1864, lng:140.7947 },
  { id:7, day:3, date:"8/9（日）", time:"11:30", name:"余市・世壱屋", note:"豪華海膽丼；若同行者不吃海鮮，可改柿崎商店／熟食午餐備案", lat:43.1872, lng:140.7891 },
  { id:8, day:3, date:"8/9（日）", time:"14:00", name:"神居古潭", note:"途中砂川休息・峽谷散步", lat:43.7215, lng:142.1988 },
  { id:9, day:3, date:"8/9（日）", time:"18:00", name:"旭川・大黑屋", note:"成吉思汗烤羊肉", lat:43.7691, lng:142.3626 },
  { id:10, day:4, date:"8/10（一）", time:"09:00", name:"旭山動物園", note:"北極熊・海豹館", lat:43.7684, lng:142.4801 },
  { id:11, day:4, date:"8/10（一）", time:"12:00", name:"美瑛咖哩烏龍麵", note:"午餐・美瑛代表性在地餐，使用在地小麥、蔬菜、牛奶或豬肉，比玉米麵包更適合當正餐", lat:43.5915, lng:142.4665 },
  { id:27, day:4, date:"8/10（一）", time:"13:00", name:"美瑛選果", note:"短停買玉米麵包／農產點心與伴手禮，不作為主要午餐", lat:43.5915, lng:142.4665 },
  { id:12, day:4, date:"8/10（一）", time:"14:00", name:"四季彩之丘", note:"夏日花田", lat:43.5297, lng:142.4646 },
  { id:13, day:4, date:"8/10（一）", time:"16:00", name:"青池・白鬚瀑布", note:"白金溫泉區絕景", lat:43.4934, lng:142.6141 },
  { id:14, day:4, date:"8/10（一）", time:"19:00", name:"森林精靈露台", note:"木屋點燈・Kumagera", lat:43.3233, lng:142.3548 },
  { id:15, day:5, date:"8/11（二）", time:"08:30", name:"富田農場", note:"彩虹花田・薰衣草", lat:43.4179, lng:142.4252 },
  { id:16, day:5, date:"8/11（二）", time:"09:40", name:"北星山薰衣草園", note:"中富良野町營薰衣草園・觀光纜車・免費入園", lat:43.4084, lng:142.4211 },
  { id:17, day:5, date:"8/11（二）", time:"10:30", name:"前往北廣島", note:"富良野出發・預留午餐與移動時間", lat:43.3441, lng:142.3832 },
  { id:18, day:5, date:"8/11（二）", time:"14:00", name:"ES CON FIELD", note:"職棒球賽・Tower 11", lat:42.9905, lng:141.5497 },
  { id:19, day:5, date:"8/11（二）", time:"晚間", name:"Vessel Inn 中島公園", note:"札幌住宿", lat:43.0482, lng:141.3557 },
  { id:20, day:6, date:"8/12（三）", time:"10:00", name:"札幌市區", note:"二條市場・大通公園", lat:43.0597, lng:141.3532 },
  { id:21, day:6, date:"8/12（三）", time:"14:00", name:"新千歲機場", note:"還車・JX851 16:25 新千歲 → 19:35 桃園", lat:42.7752, lng:141.6923 },
];

export const days = [
  { day:0,date:"8/6（四）",area:"台南・板橋",stay:"前泊／隔日桃園出發",tone:"#6f6479" },
  { day:1,date:"8/7（五）",area:"桃園・新千歲・白老",stay:"汐之湯溫泉",tone:"#79508e" },
  { day:2,date:"8/8（六）",area:"白老・京極・仁木",stay:"Domaine Bless",tone:"#327078" },
  { day:3,date:"8/9（日）",area:"余市・旭川",stay:"高砂溫泉旅館",tone:"#b36a43" },
  { day:4,date:"8/10（一）",area:"美瑛・富良野",stay:"富良野",tone:"#39718e" },
  { day:5,date:"8/11（二）",area:"富良野・中富良野・北廣島・札幌",stay:"Vessel Inn 中島公園",tone:"#667443" },
  { day:6,date:"8/12（三）",area:"札幌・返程",stay:"—",tone:"#8b6e53" },
];

export const routes: Record<number,string> = {
  0:"台南 → 板橋", 1:"桃園機場 → 新千歲機場 → Mother's Plus 白老 → Darumatei Shiraoi", 2:"白老聚會 → ナチュの森 → ㈱山珍 → かに太郎 → 京極 → 仁木・余市", 3:"余市 → 道の駅 スペース・アップルよいち → 神居古潭 → 旭川",
  4:"旭川 → 旭山動物園 → 美瑛咖哩烏龍麵 → 美瑛選果 → 四季彩之丘 → 青池 → 富良野", 5:"富田農場 → 北星山薰衣草園 → 北廣島 → 札幌", 6:"札幌 → 新千歲機場",
};

export const photos = {
  airport:"https://commons.wikimedia.org/wiki/Special:FilePath/New_CHITOSE_Airport_terminal.jpg?width=960",
  shiraoi:"https://commons.wikimedia.org/wiki/Special:FilePath/Shiraoi-upopoy_14.jpg?width=960",
  kyogoku:"https://commons.wikimedia.org/wiki/Special:FilePath/Japan-Hokkaido%2C_Kyogoku%2C_Fukidashi_Park_2014_%2815348411082%29.jpg?width=960",
  kamui:"https://commons.wikimedia.org/wiki/Special:FilePath/Kamuikotan_Asahikawa_18-05-22.jpg?width=960",
  zoo:"https://commons.wikimedia.org/wiki/Special:FilePath/Asahiyama_polar_bear.jpg?width=960",
  biei:"https://commons.wikimedia.org/wiki/Special:FilePath/140726_Shikisai-no-oka_Biei_Hokkaido_Japan01n.jpg?width=960",
  bluePond:"https://commons.wikimedia.org/wiki/Special:FilePath/Biei_Blue-pond.jpg?width=960",
  ningle:"https://commons.wikimedia.org/wiki/Special:FilePath/130503_Ningle_Terrace_Furano_Hokkaido_Japan01s3.jpg?width=960",
  tomita:"https://commons.wikimedia.org/wiki/Special:FilePath/Farm_Tomita_1.jpg?width=960",
  stadium:"https://commons.wikimedia.org/wiki/Special:FilePath/ES_CON_FIELD_HOKKAIDO_stand_and_ground_from_left_outfield.jpg?width=960",
  sapporo:"https://commons.wikimedia.org/wiki/Special:FilePath/Odori_Park_%2815982613668%29.jpg?width=960",
};

export function photoFor(stop: Stop) {
  if (stop.name.includes("機場")) return photos.airport;
  if (stop.name.includes("白老") || stop.name.includes("Darumatei") || stop.name.includes("Mother") || stop.name.includes("ナチュ") || stop.name.includes("山珍") || stop.name.includes("かに太郎")) return photos.shiraoi;
  if (stop.name.includes("京極")) return photos.kyogoku;
  if (stop.name.includes("神居")) return photos.kamui;
  if (stop.name.includes("アップル") || stop.name.includes("余市")) return photos.kamui;
  if (stop.name.includes("動物園")) return photos.zoo;
  if (stop.name.includes("青池")) return photos.bluePond;
  if (stop.name.includes("森林精靈")) return photos.ningle;
  if (stop.name.includes("富田") || stop.name.includes("北星山")) return photos.tomita;
  if (stop.name.includes("ES CON")) return photos.stadium;
  if (stop.day === 4) return photos.biei;
  if (stop.day === 5 || stop.day === 6) return photos.sapporo;
  if (stop.day === 3) return photos.kamui;
  return photos.biei;
}

export const dayPhotos: Record<number,string> = { 0:photos.airport, 1:photos.shiraoi, 2:photos.kyogoku, 3:photos.kamui, 4:photos.bluePond, 5:photos.tomita, 6:photos.sapporo };

export const travelTips = [
  {
    title: "北星山薰衣草園／中富良野町營薰衣草園",
    items: [
      "位置：中富良野町宮町 1-41，距富田農場約 1–2 公里，開車順路約 5 分鐘。",
      "建議停留：40–60 分鐘；若只拍照不搭纜車可抓 25–35 分鐘。",
      "停車：夏季約 83 台＋巴士 5 台；一般停車通常免費，旺季早上較好停。",
      "門票：園區入園免費；搭觀光纜車另計。",
      "觀光纜車：2026 年公告營運 6/13–8/23；單人座，登頂約 5 分半。",
      "參考票價：大人往返 700 日圓、兒童（小・中學生）往返 350 日圓、未就學兒免費；以現場公告為準。",
      "注意：惡天候可能停駛；不可抱小孩或寵物搭乘，需能獨立乘坐。",
    ],
  },
  {
    title: "8/8 白老短停：ナチュの森・山珍・かに太郎",
    items: [
      "ナチュの森 あそびのひろば：白老町虎杖浜 393-12，室內氣墊遊具與彈跳墊，適合小學生放電。",
      "あそびのひろば費用：小學生以下 ¥700／1 小時，成人 ¥500／1 小時，0 歲免費；以現場公告為準。",
      "あそびのひろば營業：多為週六、週日與假日 10:00–16:30，最晚入場 15:30；建議出發前確認。",
      "㈱山珍：主買魷魚絲、魷魚珍味、干貝唇、魚乾、昆布等常溫小包裝伴手禮。",
      "山珍採買建議：優先選真空包裝／常溫保存，冷藏海鮮與鱈魚子不建議旅程前段大量購買。",
      "かに太郎午餐：目前排 12:05–12:50，需控制用餐時間；若排隊超過 20 分鐘，建議縮短京極停留。",
      "行車安全：13:00 離開白老是目標時間，14:00 後才離開會壓縮京極與仁木／余市並增加傍晚趕路壓力。",
    ],
  },
  {
    title: "DAY 3 余市町道の駅：スペース・アップルよいち",
    items: [
      "定位：余市町的道之站，適合 DAY 3 上午短停、上廁所、買蘋果派與在地水果加工品。",
      "導航資訊：電話 0135-22-1515；地點就在國道 229 旁，開車導航搜尋余市町道の駅或電話都很方便。",
      "推薦品項：蘋果派、蘋果汁、果醬、蘋果甜點、葡萄／余市水果相關伴手禮；品項與數量以現場供應為準。",
      "建議停留：20–30 分鐘即可，適合作為果園或海鮮午餐前後的輕量休息點。",
      "親子優點：比海鮮丼店更容易讓小孩接受，可買甜點、果汁與點心，不涉及生食。",
      "行程接法：09:00 果園後可 10:30 短停；若取消果園，也可改 10:20–10:50 道の駅，再接柿崎商店或一般午餐。",
    ],
  },
  {
    title: "DAY 3 備案：砂川ハイウェイオアシス／北海道子どもの国",
    items: [
      "適用情境：若 8/9 不去山本觀光果園，可改成往旭川途中順遊砂川休息站與北海道子どもの国。",
      "路線：余市 → 余市・世壱屋午餐 → 砂川ハイウェイオアシス／北海道子どもの国 → 神居古潭 → 旭川。",
      "推薦原因：比小樽天狗山更順路，符合往旭川北上的方向，不需要往小樽折返。",
      "親子優點：北海道子どもの国有戶外遊具、草地與散步空間，適合 9 歲女童放電。",
      "大人優點：砂川ハイウェイオアシス可上廁所、買伴手禮、喝咖啡，適合作為長途駕車休息點。",
      "建議排程：09:30 余市／仁木出發，11:00–12:00 世壱屋午餐，13:45–15:00 砂川，16:00–16:40 神居古潭，17:20–18:00 抵達旭川。",
      "停留時間：只休息購物抓 30–40 分鐘；加兒童王國放電抓 60–75 分鐘，若玩太久需縮短神居古潭。",
    ],
  },
  {
    title: "DAY 4 旭山動物園遊玩重點與攻略",
    items: [
      "建議定位：把旭山動物園排成 2.5–3 小時精華遊，上午看重點館，約 11:45–12:00 離園往美瑛午餐。",
      "三大必看：企鵝館、海豹館、北極熊館；建議入園後優先安排，避免後面排隊或時間不足。",
      "推薦動線：企鵝館 → 海豹館 → 北極熊館 → 猛獸館 → 長頸鹿／河馬館 → 伴手禮店。",
      "精華 2 小時版：09:00 入園，09:10 企鵝館，09:40 海豹館，10:10 北極熊館，10:40 猛獸館，11:15 長頸鹿／河馬館，11:45 離園。",
      "充裕 3 小時版：09:00–10:30 企鵝／海豹／北極熊，10:30–11:30 猛獸館／狼館／猴山，11:30–12:00 長頸鹿／河馬館。",
      "親子重點：9 歲小孩通常會喜歡海豹圓柱水槽與企鵝水中隧道；園區有坡，請穿好走的鞋。",
      "夏季提醒：帽子、水壺、防曬必備；天氣熱時中午前離園較舒服，也較不壓縮下午美瑛與青池行程。",
      "現場攻略：もぐもぐタイム餵食時間每天不同，入園後先看公告，再微調順序。",
    ],
  },
  {
    title: "DAY 4 在地午餐：美瑛咖哩烏龍麵＋美瑛選果短停",
    items: [
      "主餐建議改為美瑛咖哩烏龍麵：美瑛代表性在地餐，常見特色為在地小麥、蔬菜、牛奶或豬肉。",
      "安排方式：12:00 先吃美瑛咖哩烏龍麵，13:00 再到美瑛選果短停買玉米麵包、農產點心與伴手禮。",
      "推薦原因：比只吃玉米麵包更像正餐，在地感高，也不太破壞旭山動物園 → 美瑛 → 四季彩之丘的路線。",
      "親子備案：若小孩想吃更熟悉口味，可考慮富良野蛋包咖哩／オムカレー，但可能需稍微繞進富良野市區。",
    ],
  },
];
